import LinkCard from './LinkCard.tsx'

export default function LinkList({ linkPreviews, isOwner }) {
	return (
		<div className="mx-auto w-full px-0">
			<div className="grid grid-cols-1 gap-x-4 gap-y-8 sm:grid-cols-3 lg:gap-x-6 xl:gap-x-8">
				{linkPreviews.map(linkPreview => {
					console.log('linkPreview :>> ', linkPreview)
					const { id, url, title, image, siteName } = linkPreview
					return (
						<LinkCard
							key={id}
							id={id}
							url={url}
							title={title}
							image={image}
							siteName={siteName}
							isOwner={isOwner}
						/>
					)
				})}
			</div>
		</div>
	)
}
